// frontend/src/api/followUpAPI.js
import axios from 'axios';
import { API_BASE_URL, authHeader } from './axiosConfig';

// Must match backend/models/followUp.js's RESOLUTION_OUTCOMES exactly — the
// backend is the source of truth (it rejects anything else with a 400), this
// is just so the dialog doesn't need a round trip to show the choices.
export const RESOLUTION_OUTCOMES = ['Won', 'Lost', 'No response', 'Resolved', 'Other'];

const followUpAPI = {
  // mine=true narrows a manager to their own work. A sales user is restricted
  // server-side either way, so the flag cannot widen anyone's view.
  list: ({ mine = false, days = 14 } = {}) =>
    axios.get(`${API_BASE_URL}/follow-ups`, {
      headers: authHeader(),
      params: { ...(mine ? { mine: true } : {}), days },
    }).then(r => r.data),

  summary: ({ mine = false, days = 14 } = {}) =>
    axios.get(`${API_BASE_URL}/follow-ups/summary`, {
      headers: authHeader(),
      params: { ...(mine ? { mine: true } : {}), days },
    }).then(r => r.data),

  // Tick it off. For a task this completes it instead of clearing the date —
  // an open task with no due date would vanish from the queue while still
  // being unfinished everywhere else. outcome is required (one of
  // RESOLUTION_OUTCOMES below) — the backend rejects the request without it.
  resolve: (kind, id, outcome, note) =>
    axios.patch(`${API_BASE_URL}/follow-ups/${kind}/${id}`, { mode: 'resolve', outcome, note },
      { headers: authHeader() }).then(r => r.data),

  // Move it to a new date. `until` must be 'YYYY-MM-DD'.
  snooze: (kind, id, until) =>
    axios.patch(`${API_BASE_URL}/follow-ups/${kind}/${id}`, { mode: 'snooze', until },
      { headers: authHeader() }).then(r => r.data),

  // Full history of everything ever marked Done — outcome, note, who, when.
  // Returns { rows, total }; server-paged since this only grows over time.
  cleared: ({ mine = false, limit = 25, offset = 0 } = {}) =>
    axios.get(`${API_BASE_URL}/follow-ups/cleared`, {
      headers: authHeader(),
      params: { ...(mine ? { mine: true } : {}), limit, offset },
    }).then(r => r.data),
};

export default followUpAPI;
